import React from 'react';
import gql from 'graphql-tag';
import {
  ReactFormInputOptions,
  useFormControl,
  useQuery
} from '@vendure/admin-ui/react';

const GET_SOFTWARE_HOUSES = gql`
  query GetSoftwareHousesForRelationSelect {
    softwareHouses {
      items {
        id
        name
      }
    }
  }
`;

interface SoftwareHouseItem {
  id: string;
  name: string;
}

interface GetSoftwareHousesData {
  softwareHouses: {
    items: SoftwareHouseItem[];
  };
}

const SoftwareHouseRelationSelect = ({ readonly, formControl }: ReactFormInputOptions) => {
  const { value, setFormValue } = useFormControl();
  const { data, loading } = useQuery<GetSoftwareHousesData>(GET_SOFTWARE_HOUSES);

  const rawItems = data?.softwareHouses?.items ?? [];
  // Ordenar por ID (numérico se possível, senão lexicograficamente)
  const items = [...rawItems].sort((a, b) => {
    const aNum = Number(a.id);
    const bNum = Number(b.id);
    if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
      return aNum - bNum;
    }
    return String(a.id).localeCompare(String(b.id));
  });
  const selectedId = value?.id != null ? String(value.id) : '';

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newId = event.target.value;
    const softwareHouseControl = formControl?.parent?.get('softwareHouse');

    if (!newId) {
      setFormValue(null);
      if (softwareHouseControl) {
        softwareHouseControl.setValue('');
        softwareHouseControl.markAsDirty();
        softwareHouseControl.markAsTouched();
      }
      return;
    }
    const selected = items.find(item => String(item.id) === newId);
    if (selected) {
      setFormValue({
        __typename: 'SoftwareHouse',
        id: selected.id,
        name: selected.name
      });
      if (softwareHouseControl) {
        softwareHouseControl.setValue(selected.name);
        softwareHouseControl.markAsDirty();
        softwareHouseControl.markAsTouched();
      }
    }
  };

  return (
    <select
      className='form-control'
      data-field='software-house-relation'
      disabled={readonly || loading}
      value={selectedId}
      onChange={handleChange}
    >
      <option value=''>--</option>
      {items.map(item => (
        <option key={String(item.id)} value={String(item.id)}>
          {item.id} - {item.name}
        </option>
      ))}
    </select>
  );
};

export default SoftwareHouseRelationSelect;
